(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[38641],{

/***/ 23493:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var debounce = __webpack_require__(23279),
    isObject = __webpack_require__(13218);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a throttled function that only invokes `func` at most once per
 * every `wait` milliseconds. The throttled function comes with a `cancel`
 * method to cancel delayed `func` invocations and a `flush` method to
 * immediately invoke them. Provide `options` to indicate whether `func`
 * should be invoked on the leading and/or trailing edge of the `wait`
 * timeout. The `func` is invoked with the last arguments provided to the
 * throttled function. Subsequent calls to the throttled function return the
 * result of the last `func` invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the throttled function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.throttle` and `_.debounce`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to throttle.
 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=true]
 *  Specify invoking on the leading edge of the timeout.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new throttled function.
 * @example
 *
 * // Avoid excessively updating the position while scrolling.
 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
 *
 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
 * jQuery(element).on('click', throttled);
 *
 * // Cancel the trailing throttled invocation.
 * jQuery(window).on('popstate', throttled.cancel);
 */
function throttle(func, wait, options) {
  var leading = true,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  if (isObject(options)) {
    leading = 'leading' in options ? !!options.leading : leading;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }
  return debounce(func, wait, {
    'leading': leading,
    'maxWait': wait,
    'trailing': trailing
  });
}

module.exports = throttle;


/***/ }),

/***/ 4706:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ containers_Article; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/@contentful/rich-text-plain-text-renderer/dist/rich-text-plain-text-renderer.es5.js
var rich_text_plain_text_renderer_es5 = __webpack_require__(32924);
// EXTERNAL MODULE: ./UI/components/PageHeader/index.jsx
var PageHeader = __webpack_require__(2610);
// EXTERNAL MODULE: ./components/Common/MetaTags/index.jsx + 4 modules
var MetaTags = __webpack_require__(36003);
// EXTERNAL MODULE: ./components/BlogCommon/Article/index.jsx + 2 modules
var Article = __webpack_require__(12656);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(93967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./redux/apis/dataSending.js
var dataSending = __webpack_require__(56962);
// EXTERNAL MODULE: ./hocs/withValidateEmail.js
var withValidateEmail = __webpack_require__(54639);
// EXTERNAL MODULE: ./components/Common/SubscribeBlock/styles.module.scss
var styles_module = __webpack_require__(93081);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
;// CONCATENATED MODULE: ./components/Common/SubscribeBlock/index.jsx








var SubscribeBlock = function(param) {
    var isBlog = param.isBlog, email = param.email, handleOnEmailChange = param.handleOnEmailChange, handleOnSubmit = param.handleOnSubmit;
    var ref = (0,_sliced_to_array/* default */.Z)((0,dataSending/* useSubscribeMutation */.iD)({
        fixedCacheKey: dataSending/* SUBSCRIPTION_CASH_KEY */.X3
    }), 2), _ = ref[0], ref1 = ref[1], tmp = ref1.data, ref2 = tmp === void 0 ? {} : tmp, isSubscribed = ref2.isSubscribed, message = ref2.message;
    var handleOnClick = function(event) {
        event.preventDefault();
        handleOnSubmit(email.value);
    };
    var _obj;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        className: classnames_default()((styles_module_default()).subscribeBlock, (_obj = {}, (0,_define_property/* default */.Z)(_obj, (styles_module_default()).blogPage, isBlog), (0,_define_property/* default */.Z)(_obj, (styles_module_default()).articlePage, !isBlog), _obj)),
        children: [
            !isSubscribed && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (styles_module_default()).subscribeText,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                children: "Subscribe to new posts."
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: "Get weekly updates on the newest design stories, case studies and tips right in your mailbox."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                        className: (styles_module_default()).subscribeForm,
                        onSubmit: handleOnClick,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                value: email.value,
                                onChange: handleOnEmailChange,
                                placeholder: "Your email address"
                            }),
                            message && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: (styles_module_default()).alertMessage,
                                children: message
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (styles_module_default()).button,
                                onClick: handleOnClick,
                                role: "button",
                                tabIndex: "0",
                                children: "Subscribe"
                            })
                        ]
                    })
                ]
            }),
            isSubscribed && /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                className: (styles_module_default()).subscribeTitle,
                children: "Thank you for being subscribed to the newsletter!"
            })
        ]
    });
};
SubscribeBlock.defaultProps = {
    isBlog: false
};
SubscribeBlock.propTypes = {
    isBlog: (prop_types_default()).bool,
    email: prop_types_default().instanceOf(Object).isRequired,
    handleOnEmailChange: (prop_types_default()).func.isRequired,
    handleOnSubmit: (prop_types_default()).func.isRequired
};
/* harmony default export */ var Common_SubscribeBlock = ((0,withValidateEmail/* withValidateEmail */.l)(SubscribeBlock));

// EXTERNAL MODULE: ./components/Layout/FullLayout/index.jsx
var FullLayout = __webpack_require__(22116);
;// CONCATENATED MODULE: ./node_modules/react-share/es/utils/assert.js
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var AssertionError = /** @class */ (function (_super) {
    __extends(AssertionError, _super);
    function AssertionError(message) {
        var _this = _super.call(this, message) || this;
        _this.name = 'AssertionError';
        return _this;
    }
    return AssertionError;
}(Error));
function assert(value, message) {
    if (!value) {
        throw new AssertionError(message);
    }
}

;// CONCATENATED MODULE: ./node_modules/react-share/es/utils/objectToGetParams.js
function objectToGetParams(object) {
    var params = Object.entries(object)
        .filter(function (_a) {
        var value = _a[1];
        return value !== undefined && value !== null;
    })
        .map(function (_a) {
        var key = _a[0], value = _a[1];
        return "".concat(encodeURIComponent(key), "=").concat(encodeURIComponent(String(value)));
    });
    return params.length > 0 ? "?".concat(params.join('&')) : '';
}

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./node_modules/react-share/es/ShareButton.js
var ShareButton_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (undefined && undefined.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (undefined && undefined.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};


var isPromise = function (obj) {
    return !!obj && (typeof obj === 'object' || typeof obj === 'function') && typeof obj.then === 'function';
};
var getBoxPositionOnWindowCenter = function (width, height) { return ({
    left: window.outerWidth / 2 + (window.screenX || window.screenLeft || 0) - width / 2,
    top: window.outerHeight / 2 + (window.screenY || window.screenTop || 0) - height / 2,
}); };
var getBoxPositionOnScreenCenter = function (width, height) { return ({
    top: (window.screen.height - height) / 2,
    left: (window.screen.width - width) / 2,
}); };
function windowOpen(url, _a, onClose) {
    var height = _a.height, width = _a.width, configRest = __rest(_a, ["height", "width"]);
    var config = __assign({ height: height, width: width, location: 'no', toolbar: 'no', status: 'no', directories: 'no', menubar: 'no', scrollbars: 'yes', resizable: 'no', centerscreen: 'yes', chrome: 'yes' }, configRest);
    var shareDialog = window.open(url, '', Object.keys(config)
        .map(function (key) { return "".concat(key, "=").concat(config[key]); })
        .join(', '));
    if (onClose) {
        var interval_1 = window.setInterval(function () {
            try {
                if (shareDialog === null || shareDialog.closed) {
                    window.clearInterval(interval_1);
                    onClose(shareDialog);
                }
            }
            catch (e) {
                /* eslint-disable no-console */
                console.error(e);
                /* eslint-enable no-console */
            }
        }, 1000);
    }
    return shareDialog;
}
var ShareButton = /** @class */ (function (_super) {
    ShareButton_extends(ShareButton, _super);
    function ShareButton() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.openShareDialog = function (link) {
            var _a = _this.props, onShareWindowClose = _a.onShareWindowClose, _b = _a.windowHeight, windowHeight = _b === void 0 ? 400 : _b, _c = _a.windowPosition, windowPosition = _c === void 0 ? 'windowCenter' : _c, _d = _a.windowWidth, windowWidth = _d === void 0 ? 550 : _d;
            var windowConfig = __assign({ height: windowHeight, width: windowWidth }, (windowPosition === 'windowCenter'
                ? getBoxPositionOnWindowCenter(windowWidth, windowHeight)
                : getBoxPositionOnScreenCenter(windowWidth, windowHeight)));
            windowOpen(link, windowConfig, onShareWindowClose);
        };
        _this.handleClick = function (event) { return __awaiter(_this, void 0, void 0, function () {
            var _a, beforeOnClick, disabled, networkLink, onClick, url, openShareDialogOnClick, opts, link, returnVal;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this.props, beforeOnClick = _a.beforeOnClick, disabled = _a.disabled, networkLink = _a.networkLink, onClick = _a.onClick, url = _a.url, openShareDialogOnClick = _a.openShareDialogOnClick, opts = _a.opts;
                        link = networkLink(url, opts);
                        if (disabled) {
                            return [2 /*return*/];
                        }
                        event.preventDefault();
                        if (!beforeOnClick) return [3 /*break*/, 2];
                        returnVal = beforeOnClick();
                        if (!isPromise(returnVal)) return [3 /*break*/, 2];
                        return [4 /*yield*/, returnVal];
                    case 1:
                        _b.sent();
                        _b.label = 2;
                    case 2:
                        if (openShareDialogOnClick) {
                            this.openShareDialog(link);
                        }
                        if (onClick) {
                            onClick(event, link);
                        }
                        return [2 /*return*/];
                }
            });
        }); };
        return _this;
    }
    ShareButton.prototype.render = function () {
        var _a = this.props, beforeOnClick = _a.beforeOnClick, children = _a.children, className = _a.className, disabled = _a.disabled, disabledStyle = _a.disabledStyle, forwardedRef = _a.forwardedRef, networkLink = _a.networkLink, networkName = _a.networkName, onShareWindowClose = _a.onShareWindowClose, openShareDialogOnClick = _a.openShareDialogOnClick, opts = _a.opts, resetButtonStyle = _a.resetButtonStyle, style = _a.style, url = _a.url, windowHeight = _a.windowHeight, windowPosition = _a.windowPosition, windowWidth = _a.windowWidth, rest = __rest(_a, ["beforeOnClick", "children", "className", "disabled", "disabledStyle", "forwardedRef", "networkLink", "networkName", "onShareWindowClose", "openShareDialogOnClick", "opts", "resetButtonStyle", "style", "url", "windowHeight", "windowPosition", "windowWidth"]);
        var newClassName = classnames_default()('react-share__ShareButton', {
            'react-share__ShareButton--disabled': !!disabled,
            disabled: !!disabled,
        }, className);
        var newStyle = resetButtonStyle
            ? __assign(__assign({ backgroundColor: 'transparent', border: 'none', padding: 0, font: 'inherit', color: 'inherit', cursor: 'pointer' }, style), (disabled && disabledStyle)) : __assign(__assign({}, style), (disabled && disabledStyle));
        return (react.createElement("button", __assign({}, rest, { "aria-label": rest['aria-label'] || networkName, className: newClassName, onClick: this.handleClick, ref: forwardedRef, style: newStyle }), children));
    };
    ShareButton.defaultProps = {
        disabledStyle: { opacity: 0.6 },
        openShareDialogOnClick: true,
        resetButtonStyle: true,
    };
    return ShareButton;
}(react.Component));
/* harmony default export */ var es_ShareButton = (ShareButton);

;// CONCATENATED MODULE: ./node_modules/react-share/es/hocs/createShareButton.js
var createShareButton_assign = (undefined && undefined.__assign) || function () {
    createShareButton_assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return createShareButton_assign.apply(this, arguments);
};


function createShareButton(networkName, link, optsMap, defaultProps) {
    function CreatedButton(props, ref) {
        var opts = optsMap(props);
        var passedProps = createShareButton_assign({}, props);
        // remove keys from passed props that are passed as opts
        var optsKeys = Object.keys(opts);
        optsKeys.forEach(function (key) {
            delete passedProps[key];
        });
        return (react.createElement(es_ShareButton, createShareButton_assign({}, defaultProps, passedProps, { forwardedRef: ref, networkName: networkName, networkLink: link, opts: optsMap(props) })));
    }
    CreatedButton.displayName = "ShareButton-".concat(networkName);
    return (0,react.forwardRef)(CreatedButton);
}
/* harmony default export */ var hocs_createShareButton = (createShareButton);

;// CONCATENATED MODULE: ./node_modules/react-share/es/LinkedinShareButton.js



function linkedinLink(url, _a) {
    var title = _a.title, summary = _a.summary, source = _a.source;
    assert(url, 'linkedin.url');
    return ('https://linkedin.com/shareArticle' +
        objectToGetParams({ url: url, mini: 'true', title: title, summary: summary, source: source }));
}
var LinkedinShareButton = hocs_createShareButton('linkedin', linkedinLink, function (_a) {
    var title = _a.title, summary = _a.summary, source = _a.source;
    return ({ title: title, summary: summary, source: source });
}, {
    windowWidth: 750,
    windowHeight: 600,
});
/* harmony default export */ var es_LinkedinShareButton = (LinkedinShareButton);

;// CONCATENATED MODULE: ./node_modules/react-share/es/TwitterShareButton.js



function twitterLink(url, _a) {
    var title = _a.title, via = _a.via, _b = _a.hashtags, hashtags = _b === void 0 ? [] : _b, _c = _a.related, related = _c === void 0 ? [] : _c;
    assert(url, 'twitter.url');
    assert(Array.isArray(hashtags), 'twitter.hashtags is not an array');
    assert(Array.isArray(related), 'twitter.related is not an array');
    return ('https://twitter.com/share' +
        objectToGetParams({
            url: url,
            text: title,
            via: via,
            hashtags: hashtags.length > 0 ? hashtags.join(',') : undefined,
            related: related.length > 0 ? related.join(',') : undefined,
        }));
}
var TwitterShareButton = hocs_createShareButton('twitter', twitterLink, function (props) { return ({
    hashtags: props.hashtags,
    title: props.title,
    via: props.via,
    related: props.related,
}); }, {
    windowWidth: 550,
    windowHeight: 400,
});
/* harmony default export */ var es_TwitterShareButton = (TwitterShareButton);

;// CONCATENATED MODULE: ./node_modules/react-share/es/FacebookShareButton.js



function facebookLink(url, _a) {
    var quote = _a.quote, hashtag = _a.hashtag;
    assert(url, 'facebook.url');
    return ('https://www.facebook.com/sharer/sharer.php' +
        objectToGetParams({
            u: url,
            quote: quote,
            hashtag: hashtag,
        }));
}
var FacebookShareButton = hocs_createShareButton('facebook', facebookLink, function (props) { return ({
    quote: props.quote,
    hashtag: props.hashtag,
}); }, {
    windowWidth: 550,
    windowHeight: 400,
});
/* harmony default export */ var es_FacebookShareButton = (FacebookShareButton);

// EXTERNAL MODULE: ./utils/ga.js
var ga = __webpack_require__(48114);
// EXTERNAL MODULE: ./utils/constants.js
var constants = __webpack_require__(96076);
// EXTERNAL MODULE: ./components/BlogCommon/Article/ShareThumbnails/styles.module.scss
var ShareThumbnails_styles_module = __webpack_require__(51974);
var ShareThumbnails_styles_module_default = /*#__PURE__*/__webpack_require__.n(ShareThumbnails_styles_module);
;// CONCATENATED MODULE: ./components/BlogCommon/Article/ShareThumbnails/index.jsx








var Svg = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 6778).then(__webpack_require__.bind(__webpack_require__, 6778));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(6778)
            ];
        }
    }
});
var ShareThumbnails = function(param) {
    var url = param.url, title = param.title;
    var asPath = (0,router.useRouter)().asPath;
    var trackSocialShareClick = function(param) {
        var target = param.target;
        ga/* default.trackEvent */.Z.trackEvent("Click social go to share", target.getAttribute("data-socialname"), asPath);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (ShareThumbnails_styles_module_default()).socialThumbnails,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(es_LinkedinShareButton, {
                url: url,
                title: title,
                className: (ShareThumbnails_styles_module_default()).svg,
                "data-socialname": "LinkedIn",
                onClick: trackSocialShareClick,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Svg, {
                    type: constants/* SVG_IMAGES_TYPES.linkedinFilledWhite */.NL.linkedinFilledWhite
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(es_TwitterShareButton, {
                url: url,
                title: title,
                className: (ShareThumbnails_styles_module_default()).svg,
                "data-socialname": "Twitter",
                onClick: trackSocialShareClick,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Svg, {
                    type: constants/* SVG_IMAGES_TYPES.twitterFilledWhite */.NL.twitterFilledWhite
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(es_FacebookShareButton, {
                url: url,
                quote: title,
                className: (ShareThumbnails_styles_module_default()).svg,
                "data-socialname": "Facebook",
                onClick: trackSocialShareClick,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Svg, {
                    type: "facebookFilledWhite"
                })
            })
        ]
    });
};
ShareThumbnails.defaultProps = {
    title: ""
};
ShareThumbnails.propTypes = {
    url: (prop_types_default()).string.isRequired,
    title: (prop_types_default()).string
};

// EXTERNAL MODULE: ./components/BlogCommon/Article/TagsBlock/index.jsx
var TagsBlock = __webpack_require__(65132);
// EXTERNAL MODULE: ./containers/PageNotFound/index.jsx + 1 modules
var PageNotFound = __webpack_require__(25418);
// EXTERNAL MODULE: ./redux/apis/blog.js + 2 modules
var blog = __webpack_require__(62736);
// EXTERNAL MODULE: ./utils/helper.js
var helper = __webpack_require__(6572);
// EXTERNAL MODULE: ./utils/breadcrumbs.js
var utils_breadcrumbs = __webpack_require__(84047);
// EXTERNAL MODULE: ./hooks/usePageClusters.js
var usePageClusters = __webpack_require__(70080);
// EXTERNAL MODULE: ./containers/Article/utils/propsHelper.js
var propsHelper = __webpack_require__(76259);
;// CONCATENATED MODULE: ./containers/Article/index.jsx





















var FAQ = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 5292).then(__webpack_require__.bind(__webpack_require__, 5292));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(5292)
            ];
        }
    }
});
var ArticleContainer = function(param) {
    var introSection = param.introSection, query = param.query;
    var ref = (0,_sliced_to_array/* default */.Z)((0,dataSending/* useSubscribeMutation */.iD)({
        fixedCacheKey: dataSending/* SUBSCRIPTION_CASH_KEY */.X3
    }), 2), subscribe = ref[0], ref1 = ref[1], isSubscribeLoading = ref1.isLoading;
    var ref2 = (0,blog/* useGetArticleQuery */.nB)(query), _data = ref2.data, data = _data === void 0 ? {} : _data, isError = ref2.isError, isLoading = ref2.isLoading;
    var article = data.article, olderArticle = data.next, newerArticle = data.prev, related = data.related;
    var pageClusters = (0,usePageClusters/* default */.Z)();
    var ref3 = (0,router.useRouter)(), slug = ref3.query.slug, pathname = ref3.pathname, asPath = ref3.asPath;
    if (isError) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(PageNotFound/* default */.Z, {});
    }
    if (isLoading) {
        return null;
    }
    // const { slug: prevArticleSlug } = olderArticle;
    // const { slug: nextArticleSlug } = newerArticle;
    var ref4 = (0,propsHelper/* getArticleProps */.R)({
        article: article
    }), articleSlug = ref4.slug, title = ref4.title, oldBody = ref4.oldBody, body = ref4.body, introduction = ref4.introduction, publishedAt = ref4.publishedAt, updatedAt = ref4.updatedAt, tagsList = ref4.tagsList, _categoryTag = ref4.categoryTag, categoryTag = _categoryTag === void 0 ? "" : _categoryTag, metaTitle = ref4.metaTitle, metaDescription = ref4.metaDescription, headImage = ref4.headImage, author = ref4.author, faqList = ref4.faqList;
    var articleMetadata = {
        metaTitle: metaTitle || title && "".concat(title, " | Yellow"),
        metaDescription: metaDescription || title && "Read our new article about ".concat(title, "."),
        publishedAt: publishedAt,
        image: headImage.url,
        keyWords: tagsList.map(function(tag) {
            return tag.title;
        }),
        categoryTag: categoryTag,
        slug: articleSlug,
        url: "".concat(helper/* rootUrl */.Wd).concat(asPath)
    };
    var articleData = {
        metaTitle: metaTitle,
        title: title,
        publishedAt: publishedAt,
        updatedAt: updatedAt,
        headImage: headImage.url,
        articleBody: oldBody || (0,rich_text_plain_text_renderer_es5/* documentToPlainTextString */.a)(body),
        author: author
    };
    var breadcrumbs = (0,utils_breadcrumbs/* getBreadcrumbs */.Z)(constants/* PAGES.article */.q5.article, {
        title: title,
        slug: articleSlug
    });
    var handleOnFormSubmit = function(email) {
        if (isSubscribeLoading) {
            return;
        }
        subscribe({
            email: email,
            pathname: pathname,
            pageClusters: pageClusters
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MetaTags/* default */.Z, {
                page: constants/* PAGES.article */.q5.article,
                isArticle: true,
                pageMetadata: articleMetadata,
                breadcrumbs: breadcrumbs,
                microData: articleData
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(FullLayout/* default */.Z, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PageHeader/* default */.Z, {
                        breadcrumbs: breadcrumbs,
                        breadcrumbsTheme: "dark"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Article/* default */.Z, {
                        slug: articleSlug,
                        title: title,
                        oldBody: oldBody,
                        body: body,
                        introduction: introduction,
                        headImage: headImage,
                        introSection: introSection,
                        author: author,
                        publishedAt: publishedAt
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ShareThumbnails, {
                        url: "".concat(helper/* rootUrl */.Wd, "/blog/").concat(slug),
                        title: title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FullLayout/* default */.Z, {
                        disableMaxWidth: true,
                        disableTopPadding: true,
                        disableSidePadding: true,
                        disableBottomPadding: true,
                        children: !!faqList.length && /*#__PURE__*/ (0,jsx_runtime.jsx)(FAQ, {
                            isArticalPage: true,
                            faqList: faqList
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TagsBlock/* TagsBlock */.l, {
                        tags: tagsList
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Common_SubscribeBlock, {
                        handleOnSubmit: handleOnFormSubmit
                    })
                ]
            })
        ]
    });
};
ArticleContainer.propTypes = {
    introSection: prop_types_default().instanceOf(Object).isRequired
};
/* harmony default export */ var containers_Article = (ArticleContainer);


/***/ }),

/***/ 70080:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ usePageClusters; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(29815);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var redux_apis_blog__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(62736);
/* harmony import */ var redux_apis_page__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(85144);
/* harmony import */ var utils_appContext__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(16515);
/* harmony import */ var utils_helper__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6572);






function usePageClusters() {
    var pageFetchQuery = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(utils_appContext__WEBPACK_IMPORTED_MODULE_1__/* .PageFetchContext */ .E).pageFetchQuery;
    var ref = (0,redux_apis_blog__WEBPACK_IMPORTED_MODULE_2__/* .useGetArticleQuery */ .nB)(pageFetchQuery), tmp = ref.data, article = (tmp === void 0 ? {} : tmp).article;
    var ref1 = (0,utils_helper__WEBPACK_IMPORTED_MODULE_3__/* .getDocumentFields */ .OA)(article, [
        "clusters"
    ]), articleClusters = ref1.clusters;
    var ref2 = (0,redux_apis_page__WEBPACK_IMPORTED_MODULE_4__/* .useFetchPageQuery */ .o)(pageFetchQuery), tmp1 = ref2.data, pageData = tmp1 === void 0 ? {} : tmp1;
    var pageClusters = pageData.clusters;
    return (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(articleClusters || []).concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(pageClusters || []));
}


/***/ }),

/***/ 51974:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"socialThumbnails":"styles_socialThumbnails__6PcZO","svg":"styles_svg__D8nvo"};

/***/ }),

/***/ 93081:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"blogPage":"styles_blogPage__xcWS5","articlePage":"styles_articlePage__n0mCc","subscribeTitle":"styles_subscribeTitle___RSFw","subscribeBlock":"styles_subscribeBlock__7aaKr","subscribeText":"styles_subscribeText__WFNbU","subscribeForm":"styles_subscribeForm__239W5","button":"styles_button__a6g7m","alertMessage":"styles_alertMessage__NUCzQ"};

/***/ })

}]);